import { useCveFilter } from './use-cve-filter'
import React from 'react'
import { Drawer } from '@contrast-security-inc/design-system-popovers'
import { Vulnerability } from '../shared'
import { Organization } from '@contrast-security-inc/base-types'
import { CveDetailBody } from './cve-body'
import { CveDetailHeader } from './cve-header'
import { styles } from './styles'
import { CvssScoringType } from '../../sca/libraries/helpers/ui-interfaces'
import { findCvssVersion } from './cveUtils'

interface CveFilterProps {
  readonly organizationUuid: string
  readonly vulnerabilityDrawerIsOpen: boolean
  readonly selectedModalVulnerability: Vulnerability
  readonly organization: Organization
  readonly setSelected: any
  setVulnerabilityDrawerIsOpen: (isOpen: boolean) => void
}
export const vulnerabilityDrawerTestID = 'cve-drawer'

export function CveFilter({
  organizationUuid,
  selectedModalVulnerability,
  organization,
  setVulnerabilityDrawerIsOpen,
  vulnerabilityDrawerIsOpen,
  setSelected
}: CveFilterProps) {
  const { data, error } = useCveFilter(
    organizationUuid,
    selectedModalVulnerability.name
  )

  if (error || !data) {
    return null
  }

  const cvss = findCvssVersion(data.cve.cvssv2, data.cve.cvssv3)
  const severityCode: string =
    organization.cvssScoringType === CvssScoringType.CVSS3_1 &&
    'cvssv3' in cvss &&
    data?.cve?.cvssv3?.severity
      ? data.cve.cvssv3.severity
      : data?.cve?.cvssv2?.severity || 'NOTE'

  return (
    <Drawer
      testId={vulnerabilityDrawerTestID}
      className={styles.drawerFormat}
      size="lg"
      isOpen={vulnerabilityDrawerIsOpen}
      header={
        <CveDetailHeader vulnerability={data} severityCode={severityCode} />
      }
      body={
        <CveDetailBody
          vulnerability={data}
          severityCode={severityCode}
          isOpen={vulnerabilityDrawerIsOpen}
          cvss={cvss}
        />
      }
      onClose={() => {
        setVulnerabilityDrawerIsOpen(false)
        setSelected(undefined)
      }}
      placement="right"
    />
  )
}
